// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 60868 ? "auth-suite-sdk" : chunkId) + "-" + {"16915":"44bee86a82e82908a9ac","44139":"1f10d6095dcca8e844e5","60868":"b66e3858af25368698aa","81270":"2f65f1ddd0991661a4f6","82530":"b161ea7b22f84beaadb9","87026":"757eb99bd890ec3a7b9a","96419":"ed7c149957e3e32ec980"}[chunkId] + ".min.js";
};